module.exports = __webpack_public_path__ + "img/img_a@2x.3dfa3c62.png";